angular.module('bmsApp.crm.customer').controller('CustomerViewStatementCtrl', function ($window,
																						$scope,
																						$filter,
																						$ngBootbox,
																						notify,
																						$timeout,
																						ngTableParams,
																						AccountingSvc) {

	$scope.tabs.statement.select = function () {
		$scope.tabs.statement.load();
	};

	$scope.tabs.statement.reload = function () {
		if (angular.isObject($scope.customerStatement)) {
			$scope.customerStatement.tableParams.reload();
		}
	};

	$scope.rangePickerConfig = angular.copy($scope.config.datePicker.range);
	$scope.rangePickerConfig.options.opens = 'left';

	$scope.tabs.statement.load = function () {

		if ($scope.tabs.statement.loaded !== true) {
			$scope.customerStatement = {
				customerId: $scope.customer.id,
				filters: {
					dateRange: {
						startDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
						endDate: moment().format('YYYY-MM-DD')
					}
				},
				params: {},
				applyFilter: function () {
					$scope.customerStatement.tableParams.$params.filter = angular.extend($scope.customerStatement.tableParams.$params.filter, {
						fromDate: $scope.customerStatement.filters.dateRange.startDate,
						toDate: $scope.customerStatement.filters.dateRange.endDate
					});
				},
				export: function () {
					var params = {
						filter: {
							fromDate: $scope.customerStatement.filters.dateRange.startDate,
							toDate: $scope.customerStatement.filters.dateRange.endDate,
							pdf: true
						}
					};
					var paramString = $.param(params);
					$window.open('api/accounting/customer-statement/' + $scope.customerStatement.customerId + '?' + paramString, '_blank');
				},
				exportInvoices: function () {
					var params = {
						customer: {
							id: $scope.customerStatement.customerId
						},
						date_from: $scope.customerStatement.filters.dateRange.startDate,
						date_to: $scope.customerStatement.filters.dateRange.endDate
					};
					var paramString = $.param(params);
					$window.open('customer/export-invoices?' + paramString, '_blank');
				},
				data: {},
				loading: true,
				tableParams: new ngTableParams({
					page: 1,
					count: $scope.config.tabbedTable.params.count
				}, {
					counts: $scope.config.tabbedTable.settings.counts,
					getData: function ($defer, params) {
						$scope.customerStatement.loading = true;
						var customerId = $scope.customerStatement.customerId;
						AccountingSvc.customerStatement(customerId, params.$params).then(function (response) {
							$defer.resolve(response.data.transactions);
							params.total(response.data.transactionsCount);
							$scope.customerStatement.data.transactionsCount = response.data.transactionsCount;
							$scope.customerStatement.loading = false;
						});
					}
				}),
				deleteCustomerPayment: function (transaction) {
					$ngBootbox.confirm('Are you sure you want to remove this payment? This can not be undone.')
						.then(function () {
							AccountingSvc.deleteCustomerPayment(transaction.id)
								.then(function () {
									notify({
										message: 'Payment deleted successfully'
									});
									$scope.loadCustomer();
									$scope.customerStatement.tableParams.reload();
								}, function (error) {
									notify({
										message: 'Failed to delete payment',
										classes: 'error'
									});
								});
						});
				}
			};

			$scope.customerStatement.applyFilter();
		}

		$scope.tabs.statement.loaded = true;

	};

});
